import Spinner from './Spinner'

Spinner.install = (Vue, options) => {
  Vue.component(Spinner.name, Spinner)
}
export default Spinner


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Spinner/index.js
// module id = null
// module chunks = 